/** Public (anonymous) API — MVP public experience (Porto Sant'Elpidio only). */
import apiClient from '@/services/api/client';

const get = async (path, params) => (await apiClient.get(path, { params })).data;

export const fetchHome = () => get('/v1/public/home');
export const fetchPublicMunicipalities = () => get('/v1/public/municipalities');
export const fetchPublicEvents = () => get('/v1/public/events');
export const fetchPublicEvent = (slug) => get(`/v1/public/events/${slug}`);
export const fetchPublicPlaces = () => get('/v1/public/places');
export const fetchPublicPlace = (slug) => get(`/v1/public/places/${slug}`);
export const fetchPublicActivities = () => get('/v1/public/activities');
export const fetchPublicActivity = (slug) => get(`/v1/public/activities/${slug}`);
export const searchPublic = (q) => get('/v1/public/search', { q });
export const fetchMapMarkers = () => get('/v1/public/map');
